import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormValuesBasic {
  selection?: string;
  NotificationType?: string;
  Title: string;
  ImageId: string;
  StartDate?: string;
  EndDate?: string;
  StartTime?: string;
  DisplayFormDate?: string;
  DisplayUptoDate?: string;
  Description: string;
  ImageUrl: string;
  isSendEmail: boolean;
  isSendMobile: boolean;
  isSendDesktop: boolean;
  Status: boolean;
  LargeIconImage: string;
  BigImageId: string;
  SmallIconImageId: string;
  LargeIconImageId: string;
  LargeIconImageUrl: string;
  SmallIconImage: string;
  SmallIconImageUrl: string;
  BigImage: string;
  BigImageUrl: string;
  LockscreenType: string;
  GroupKey: string;
  GroupMessage: string;
  AccentColor: string;
  LEDColor: string;
  StudentIds?: string;
  PackageIds?: string;
}
interface FormValuesAdv {
  AccentColor: string;
  LEDColor: string;
  LargeIconImage: string;
  LargeIconImageUrl: string;
  SmallIconImage: string;
  SmallIconImageUrl: string;
  BigImage: string;
  BigImageUrl: string;
  LockscreenType: string;
  GroupKey: string;
  GroupMessage: string;
  BigImageId: string;
  SmallIconImageId: string;
  LargeIconImageId: string
}

interface FromValueProps {
  FormValuesBasic: FormValuesBasic;
  FormValuesAdv: FormValuesAdv;
}

const initialState: FromValueProps = {
  FormValuesBasic: {
    selection: '',
    NotificationType: '',
    Title: '',
    ImageId: '',
    StartDate: '',
    EndDate: '',
    StartTime: '',
    DisplayFormDate: '',
    DisplayUptoDate: '',
    Description: '',
    ImageUrl: '',
    isSendEmail: false,
    isSendMobile: true,
    isSendDesktop: true,
    Status: true,
    LargeIconImage: '',
    BigImageId: '',
    SmallIconImageId: '',
    LargeIconImageId: '',
    LargeIconImageUrl: '',
    SmallIconImage: '',
    SmallIconImageUrl: '',
    BigImage: '',
    BigImageUrl: '',
    LockscreenType: '',
    GroupKey: '',
    GroupMessage: '',
    AccentColor: "",
    LEDColor: "",
    StudentIds: '',
    PackageIds: ''
  },
  FormValuesAdv: {
    AccentColor: "",
    LEDColor: "",
    BigImageId: '',
    SmallIconImageId: '',
    LargeIconImageId: '',
    LargeIconImage: '',
    LargeIconImageUrl: '',
    SmallIconImage: '',
    SmallIconImageUrl: '',
    BigImage: '',
    BigImageUrl: '',
    LockscreenType: '',
    GroupKey: '',
    GroupMessage: '',
  },
};

const notificationformSlice = createSlice({
  name: 'notificationformSlice',
  initialState,
  reducers: {
    updateFirstForm: (state, action: PayloadAction<FormValuesBasic>) => {
      state.FormValuesBasic = action.payload;
    },
    updateSecondForm: (state, action: PayloadAction<FormValuesAdv>) => {
      state.FormValuesAdv = action.payload;
    },
    setClearAllForm: (state) => {
      state.FormValuesBasic = { ...initialState.FormValuesBasic };
      state.FormValuesAdv = { ...initialState.FormValuesAdv };
    }
    
  },
});

export const { updateFirstForm, updateSecondForm, setClearAllForm } =
  notificationformSlice.actions;
export default notificationformSlice.reducer;
